import React, {Component} from 'react';
import {client} from '../../Client';
import { Button, Form, Input, Message, Checkbox } from 'semantic-ui-react'
import Moment from 'moment';
import {convertNullToEmptyString, arrayToCombo} from '../../Helpers'
import ErrorMessage from '../ErrorMessage'
import {Redirect} from 'react-router-dom';
import 'moment/locale/it.js';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import PropTypes from 'prop-types';

class UtentiForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.match.params.id, // Se undefined siamo in insert, altr in update
            inUpdate: this.props.match.params.id !== undefined,
            fields: this.getEmptyFields(),
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            cancelSuccess: false,
            error: null,
            itemSaved: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onInputChangeUppercase = this.onInputChangeUppercase.bind(this)
        this.onInputCheckboxChange = this.onInputCheckboxChange.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
    }

    isLoadingInProgress(){
        return this.state._loading;
    }
    componentDidMount() {
        if (this.state.inUpdate)
        {
            this.setState({ _loading: true });
            client.loadUtente(this.state.id).then(
                (response) => {
                    if (response.ok){
                        response.json().then((news) => {
                            
                            let fields = convertNullToEmptyString(news);

                            this.setState({ _loading: false, fields: fields,  fieldErrors: {},
                                fieldErrorsText: [], inError: false, error: null, itemSaved: news});
                            this.forceUpdate();
                        })
                    }
                    else if (response.status === 401)
                    {
                        this.props.history.push("/login")
                    }
                    else
                    {
                        response.json().then((errore) => {
                            let fieldErrorsText = []
                            let fieldErrors = {}
                            this.setState({
                                _loading: false,
                                fieldErrors: fieldErrors,
                                fieldErrorsText: fieldErrorsText,
                                errorTitle: '',
                                error: {title: errore.title, msg: errore.msg},
                                inError: true
                            });
                        });

                    }
            }).catch((error) => {

                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    _loading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });

            });
        }
    }

    getEmptyFields() {
        return {
            'username': '',
            'password': '',
            'nome': '',
            'email': '',
            'bkgColor1' : '#005BAB',
            'bkgColor2' : '#569EDD',
            'imgProfilo' : '',
            'roleAdmin' : false,
            'roleAttivita' : true,
            'roleGare' : true,
            'roleGareW' : true,
            'roleCommesse' : true,
            'roleCommesseW' : true,
            'roleDocumenti' : true,
            'roleDocumentiW' : true,
            'roleRubrica' : true,
            'roleRubricaW' : true,
            'roleMovimenti' : true,
            'roleMovimentiW' : true,
            'roleMovimentiExt' : true,
            'roleReport' : true,
            'roleConfigurazione' : false,
            'roleNews' : true,
            'roleNewsW' : true,
            'attivo' : true,
        }
    }

    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        if (formData.username.trim() === "")
        {
            fieldErrors["username"] = true;
            fieldErrorsText.push("username: devi fornire un valore non vuoto. Utilizzare solo caratteri alfanumerici.");
        }
    
        if (formData.username !== "")
        {
            if ( (/^[\w]+$/.test(formData.username)) === false ){
                fieldErrors["username"] = true;
                fieldErrorsText.push("Username: Utilizzare solo caratteri alfanumerici.");
            }
        }

        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    handleCancel(e) {
        e.preventDefault();
        this.setState({cancelSuccess: true})
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = this.state.fields;

        // Validazione form
        if (!this.formIsValid(formData)){
            return;
        }

        // Salvataggio sul server
        delete formData["stato-search"];
        this.setState({_loading: true});
        client.saveUtente(
            formData,
            this.state.fields.idUtente,
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    let fields = this.state.fields;
                    fields["idUtente"] = data.idUtente;
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        saveSuccess: true,
                        successTitle: "Salvataggio utente",
                        successText: "L'utente è stato salvato correttamente",
                        fields: fields,
                        itemSaved: data,
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onInputChange(a1, {name, value}){

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields });
        }
    }

    onInputCheckboxChange(a1, {name, checked}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = checked;
            this.setState({ fields });
        }
    }

    onInputChangeUppercase(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;

            fields[name] = value.toUpperCase();

            this.setState({ fields });
        }
    }

    render() {
        
        let btnSalva = null;
        if (client.getCurrentUser().isadmin){
            btnSalva = <div className="left aligned eight wide column">
                <Button primary type='submit' loading={this.isLoadingInProgress()}><i className="save icon"/> Salva</Button>
            </div>
        }else{
            btnSalva = <div className="left aligned eight wide column">
                <Button secondary disabled type='submit'><i className="save icon"/>Non hai i diritti per salvare</Button>
            </div>
        }

        if (this.state.error != null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess || this.state.cancelSuccess){

            return <Redirect to={ {
                pathname: '/app/utenti/list',
                state: {
                    from: this.props.location,
                    item: this.state.itemSaved
                },
            }}/>
        }
        let titleMsg = this.state.inUpdate ?
            <h3 className="ui block attached top header"><i className="edit icon"></i> Modifica Utente - Informazioni di base</h3>
            :
            <h3 className="ui block attached top header"><i className="add square icon"></i> Nuova Utente - Informazioni di base</h3>

        return (
            <div>
            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>

                {titleMsg}
                <div className="ui attached segment">
                <Form.Group widths="3">
                    <Form.Field width={7} label="Username" required={true} control={Input} name='username' autoComplete="nope"  placeholder='username' maxLength="250"  value={this.state.fields.username} error={this.state.fieldErrors["username"]}  onChange={this.onInputChange}/>
                    <Form.Field width={7} label="Password"  required={true} readOnly={false} control={Input} name='password' autoComplete="nope"  placeholder='password' maxLength="250"  value={this.state.fields.password} error={this.state.fieldErrors["password"]}  onChange={this.onInputChange}/>
                    <Form.Field width={2} >
                        <label>Attivo</label>
                        <Checkbox name="attivo" defaultIndeterminate={false} toggle checked={this.state.fields.attivo} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                </Form.Group>
                <Form.Group widths="2">
                    <Form.Field width={8} label="Nome" required={false} control={Input} name='nome' autoComplete="nope"  placeholder='nome' maxLength="250"  value={this.state.fields.nome} error={this.state.fieldErrors["nome"]}  onChange={this.onInputChange}/>
                    <Form.Field width={8} label="E-mail" type="email" required={true} control={Input} name='email' autoComplete="nope"  placeholder='email' maxLength="250"  value={this.state.fields.email} error={this.state.fieldErrors["email"]}  onChange={this.onInputChange}/>
                </Form.Group>

                <Form.Group widths="4">
                    <Form.Field width={4} >
                        <label>Amministratore</label>
                        <Checkbox name="roleAdmin" defaultIndeterminate={false} toggle checked={this.state.fields.roleAdmin} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Report</label>
                        <Checkbox name="roleReport" defaultIndeterminate={false} toggle checked={this.state.fields.roleReport} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Configurazione</label>
                        <Checkbox name="roleConfigurazione" defaultIndeterminate={false} toggle checked={this.state.fields.roleConfigurazione} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Attività</label>
                        <Checkbox name="roleAttivita" defaultIndeterminate={false} toggle checked={this.state.fields.roleAttivita} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                </Form.Group>
                
                <Form.Group widths="4">
                    <Form.Field width={4} >
                        <label>Gare (accesso)</label>
                        <Checkbox name="roleGare" defaultIndeterminate={false} toggle checked={this.state.fields.roleGare} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Gare (Modifica)</label>
                        <Checkbox name="roleGareW" defaultIndeterminate={false} toggle checked={this.state.fields.roleGareW} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Commesse (accesso)</label>
                        <Checkbox name="roleCommesse" defaultIndeterminate={false} toggle checked={this.state.fields.roleCommesse} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Commesse (Modifica)</label>
                        <Checkbox name="roleCommesseW" defaultIndeterminate={false} toggle checked={this.state.fields.roleCommesseW} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                </Form.Group>
                
                <Form.Group widths="4">
                    <Form.Field width={4} >
                        <label>Documenti (accesso)</label>
                        <Checkbox name="roleDocumenti" defaultIndeterminate={false} toggle checked={this.state.fields.roleDocumenti} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Documenti (Modifica)</label>
                        <Checkbox name="roleDocumentiW" defaultIndeterminate={false} toggle checked={this.state.fields.roleDocumentiW} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Rubrica (accesso)</label>
                        <Checkbox name="roleRubrica" defaultIndeterminate={false} toggle checked={this.state.fields.roleRubrica} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Rubrica (Modifica)</label>
                        <Checkbox name="roleRubricaW" defaultIndeterminate={false} toggle checked={this.state.fields.roleRubricaW} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                </Form.Group>
                
                <Form.Group widths="4">
                    <Form.Field width={4} >
                        <label>Movimenti (accesso)</label>
                        <Checkbox name="roleMovimenti" defaultIndeterminate={false} toggle checked={this.state.fields.roleMovimenti} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Movimenti (Modifica)</label>
                        <Checkbox name="roleMovimentiW" defaultIndeterminate={false} toggle checked={this.state.fields.roleMovimentiW} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>Movimenti (esteso)</label>
                        <Checkbox name="roleMovimentiExt" defaultIndeterminate={false} toggle checked={this.state.fields.roleMovimentiExt} onChange={this.onInputCheckboxChange} />
                    </Form.Field>                    
                </Form.Group>

                <Form.Group widths="4">
                    <Form.Field width={4} >
                        <label>News (accesso)</label>
                        <Checkbox name="roleNews" defaultIndeterminate={false} toggle checked={this.state.fields.roleNews} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={4} >
                        <label>News (Modifica)</label>
                        <Checkbox name="roleNewsW" defaultIndeterminate={false} toggle checked={this.state.fields.roleNewsW} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                </Form.Group>
                
                </div>
                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />

                <p></p>
                <div className="ui grid">
                    <div className="right aligned eight wide column">
                        <a onClick={this.handleCancel} className="ui right floated  secondary  button"><i className="undo icon"/>Annulla</a>
                    </div>
                    {btnSalva}
                </div>

            </Form>
            </div>
        )
    }
}

UtentiForm.contextTypes = {
    router: PropTypes.object
}

export default UtentiForm;




/** WEBPACK FOOTER **
 ** ./src/components/utenti/UtentiForm.js
 **/